import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="terminal-icon">❯</div>
        <p className="footer-text">© 2025-2026 OhNikx. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
